<template>
  <button :style="cssProps" class="button-outline" @click.prevent="onClick">{{ text }}</button>
</template>

<style scoped>
.button-outline {
  font-weight: 700;
  font-size: 18px;
  line-height: 175%;
  color: var(--color);
  background-color: #fff;
  padding: 4px 24px;
  border: 1px solid var(--color);
  border-radius: 6px;
  transition: 0.3s;
}

.button-outline:hover {
  background-color: var(--color);
  color: #fff;
}
</style>

<script>

export default {
  components: {},
  props: {
    color: {
      type: String,
      default: '#E12A12',
    },
    text: String,
    onClick: Function,
  },
  data: () => ({
    isHovering: false,
  }),
  computed: {
    cssProps() {
      return {
        '--color': this.color,
      }
    }
  }
}
</script>
